import styled from 'styled-components';
import { Wrapper } from '../../Wrapper/Wrapper';
import { Theme } from '../../../../theme/theme';

interface Props {
  isActive: boolean;
  theme: Theme;
}

export const Accordion = styled(Wrapper)(({ isActive, theme }: Props) => ({
  borderRadius: theme.radii.xl,
  border: `1px solid ${theme.colors.neutral['200']}`,
  boxShadow: isActive ? theme.shadows['300'] : 'none',
  background: theme.colors.bg,
}));
